import React from "react";
import Hero from "../../components/home/Hero";
import AboutPreview from "../../components/home/AboutPreview";
import SchoolCards from "../../components/home/SchoolCards";
import WhyChooseUs from "../../components/home/WhyChooseUs";
import Testimonials from "../../components/home/Testimonials";
import NewsHighlights from "../../components/home/NewsHighlights";
import CTASection from "../../components/home/CTASection";

const Home = () => {
  return (
    <>
      <Hero />
      <AboutPreview />
      <SchoolCards />
      <WhyChooseUs />
      {/* <Testimonials /> */}
      {/* <NewsHighlights /> */}
      <CTASection />
    </>
  );
};

export default Home;
